<template>
  <v-card color="grey lighten-3">
    <v-card-title>{{ $t("CourseWeeks") }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="course.courseWeeks"
        :loading="loading"
        :options="options"
        class="mt-3"
        item-name="name"
      >
        <template v-slot:item.from="{ item }">
          {{ item ? moment(item.from).format("DD.MM.YYYY") : "-" }}
        </template>
        <template v-slot:item.to="{ item }">
          {{ item ? moment(item.to).format("DD.MM.YYYY") : "-" }}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
          <v-icon small @click="duplicateItem(item)">
            mdi-content-duplicate
          </v-icon>
        </template>
      </v-data-table>
      <div class="text-right">
        <v-btn @click="addItem" class=" mt-2 align-right">
          <v-icon small>
            mdi-plus
          </v-icon>
          {{ $t("CourseWeek") }}
        </v-btn>
      </div>
    </v-card-text>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="false"
      max-width="800"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          {{ $t("CourseWeek") }}
          {{ this.courseWeek.id ? $t("Edit") : $t("createResource") }}
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
            v-if="courseWeek"
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="courseWeek.name"
                  :label="$t('name')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="name"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="courseWeek.name_it"
                  :label="$t('name_it')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="name_it"
                  :error-messages="errors.collect('name_it')"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row>
              <v-col>
                <v-textarea
                  v-model="courseWeek.description"
                  :label="$t('description')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="description"
                  :error-messages="errors.collect('description')"
                ></v-textarea>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="courseWeek.description_it"
                  :label="$t('description_it')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="description_it"
                  :error-messages="errors.collect('description_it')"
                ></v-textarea>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col>
                <base-date-picker
                  v-model="courseWeek.from"
                  :label="$t('Course') + ' ' + $t('from')"
                  v-validate="'required'"
                  data-vv-name="from"
                  :error-messages="errors.collect('from')"
                ></base-date-picker>
              </v-col>
              <v-col>
                <base-date-picker
                  v-model="courseWeek.to"
                  :label="$t('Course') + ' ' + $t('to')"
                  v-validate="'required'"
                  data-vv-name="from"
                  :error-messages="errors.collect('from')"
                ></base-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="courseWeek.max_participants"
                  :label="$t('max_participants')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="max_participants"
                  :error-messages="errors.collect('max_participants')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="courseWeek.waiting_list"
                  :label="$t('waiting_list')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="waiting_list"
                  :error-messages="errors.collect('waiting_list')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-text>
                    <v-checkbox
                      v-model="courseWeek.half_day"
                      :label="
                        $i18n.locale == 'de'
                          ? course.label_half_day_de
                          : course.label_half_day_it
                      "
                    ></v-checkbox>
                    <v-text-field
                      v-model="courseWeek.price_half_day"
                      :label="$t('price_half_day')"
                      autocomplete="new-password"
                      v-validate="'required'"
                      required
                      data-vv-name="price_half_day"
                      :error-messages="errors.collect('price_half_day')"
                      v-if="courseWeek.half_day"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-text>
                    <v-checkbox
                      v-model="courseWeek.full_day"
                      :label="
                        $i18n.locale == 'de'
                          ? course.label_full_day_de
                          : course.label_full_day_it
                      "
                    ></v-checkbox>
                    <v-text-field
                      v-model="courseWeek.price"
                      :label="$t('price')"
                      autocomplete="new-password"
                      v-validate="'required'"
                      required
                      data-vv-name="price"
                      :error-messages="errors.collect('price')"
                      v-if="courseWeek.full_day"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p>{{ $t("time_info_de") }}</p>
                <VueEditor
                  v-model="courseWeek.time_info_de"
                  :label="$t('time_info_de')"
                  autocomplete="new-password"
                  v-validate=""
                  data-vv-name="time_info_de"
                  :error-messages="errors.collect('time_info_de')"
                  :editor-toolbar="customToolbar"
                ></VueEditor>
              </v-col>
              <v-col>
                <p>{{ $t("time_info_it") }}</p>
                <VueEditor
                  v-model="courseWeek.time_info_it"
                  :label="$t('time_info_it')"
                  autocomplete="new-password"
                  v-validate=""
                  data-vv-name="time_info_it"
                  :error-messages="errors.collect('time_info_it')"
                  :editor-toolbar="customToolbar"
                ></VueEditor>
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col>
                <p>{{ $t("image") }}</p>
                <v-file-input
                  v-if="courseWeek.image == null"
                  filled
                  prepend-icon="mdi-camera"
                  v-model="chosenImage"
                  truncate-length="15"
                  show-size
                  v-on:change="onChangeImageUpload()"
                ></v-file-input>
                <div v-else>
                  <v-img :src="courseWeek.image" aspect-ratio="2"> </v-img>
                  <v-btn
                    @click="
                      courseWeek.image = null;
                      $forceUpdate();
                    "
                    class="mt-2"
                    color="error"
                    >{{ $t("image") }} {{ $t("delete") }}</v-btn
                  >
                </div>
              </v-col> -->
              <v-col>
                <p>{{ $t("program") }}</p>
                <v-file-input
                  v-if="courseWeek.program == null"
                  filled
                  prepend-icon="mdi-file"
                  v-model="chosenFile"
                  truncate-length="15"
                  show-size
                  v-on:change="onChangeFileUpload()"
                ></v-file-input>
                <div v-else>
                  <v-btn
                    class="mt-2 mr-2"
                    taregt="_blank"
                    :href="courseWeek.program"
                    >{{ $t("program") }} {{ $t("download") }}
                  </v-btn>
                  <v-btn
                    @click="
                      courseWeek.program = null;
                      $forceUpdate();
                    "
                    class="mt-2"
                    color="error"
                    >{{ $t("program") }} {{ $t("delete") }}</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ma-1" color="secondary" @click="closeDialog">
            {{ $t("close") }}
          </v-btn>
          <v-btn class="ma-1" color="primary" @click="saveItem">
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { saveCourseWeek, deleteCourseWeek } from "../shared/services";
export default {
  name: "courseWeek",
  data() {
    return {
      loading: false,
      dialog: false,
      courseWeek: null,
      chosenImage: null,
      chosenFile: null,
      options: {
        itemsPerPage: -1
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }]
      ]
    };
  },
  props: {
    course: null
  },
  computed: {
    headers() {
      return [
        { text: this.$t("name"), value: "name", sortable: false },
        {
          text:
            this.$t("price") +
            " " +
            (this.course
              ? this.$i18n.locale == "de"
                ? this.course.label_half_day_de
                : this.course.label_half_day_it
              : this.$t("half_day")),
          value: "price_half_day",
          sortable: false
        },
        {
          text:
            this.$t("price") +
            " " +
            (this.course
              ? this.$i18n.locale == "de"
                ? this.course.label_full_day_de
                : this.course.label_full_day_it
              : this.$t("full_day")),
          value: "price",
          sortable: false
        },
        { text: this.$t("from"), value: "from", sortable: false },
        { text: this.$t("to"), value: "to", sortable: false },
        { text: "", value: "action", sortable: false }
      ];
    }
  },
  mounted() {
    this.resetItem();
  },
  methods: {
    addItem() {
      this.resetItem();
      this.dialog = true;
    },
    resetItem() {
      this.courseWeek = {
        name: null,
        name_it: null,
        description: null,
        description_it: null,
        course_id: this.$route.params.id,
        from: null,
        to: null
      };
    },
    editItem(item) {
      this.courseWeek = item;
      this.dialog = true;
    },
    duplicateItem(item) {
      this.courseWeek = item;
      delete this.courseWeek.id;
      this.dialog = true;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("CourseWeek") + " " + this.$t("really delete?")
        )
      ) {
        let resp = await deleteCourseWeek(item.id);
        if (resp.data.success) {
          this.$notification(resp.data.message, { type: "success" });
        } else {
          this.$notification(resp.data.message, { type: "error" });
        }
        location.reload();
      }
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveCourseWeek(
        this.courseWeek.id,
        this.courseWeek,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({
          name: "course.edit",
          params: { id: this.courseWeek.course_id }
        });
        this.dialog = false;
        location.reload();
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    onChangeFileUpload() {
      this.fileUpload("file");
    },
    onChangeImageUpload() {
      this.fileUpload("image");
    },
    fileUpload(type) {
      if (this.chosenImage || this.chosenFile) {
        let formData = new FormData();
        this.uploaderLoading = true;
        if (type == "image") {
          formData.append("image", this.chosenImage);
        } else {
          formData.append("file", this.chosenFile);
        }
        this.axios
          .post("/api/course/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(data => {
            this.uploaderLoading = false;
            this.chosenFile = null;
            this.chosenImage = null;
            if (type == "file") {
              this.courseWeek.program = data.data;
            } else {
              this.courseWeek.image = data.data;
            }
          })
          .catch(error => {
            this.loading = false;
            for (let field in error.response.data.errors) {
              this.$validator.errors.add({
                field: field,
                msg: error.response.data.errors[field][0]
              });
            }
            throw error;
          });
      }
    }
  }
};
</script>
